import { UserState } from "redux-oidc";
import { actionCreators as appActionCreators, AppState } from "./App";
export { AppState } from "./App";
export * from "./models";
export * from "./utils";

export type OidcState = UserState;

export type AppActions = typeof appActionCreators;

export interface BaseApplicationState {
  oidc: OidcState;
  app: AppState;
}

export const baseActionCreators = {
  app: appActionCreators,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export type AppThunkAction<TAction, TState> = (dispatch: (action: TAction) => void, getState: () => TState) => void;
